import Vue from 'vue'

import { api } from '@/services'
import store from '@/store'
import { getUser } from '@/services/auth/user'

export const login = ({ username, password }) =>
  api
    .login({ username, password })
    .then(({ data }) => {
      const jwtJson = JSON.parse(window.atob(data?.access_token?.split('.')[1]));

      Promise.resolve(jwtJson)
        .then(async (jwt) => {
          try {
            localStorage.setItem('access_roles', jwt?.authorities)
            localStorage.setItem('refresh_token', data?.refresh_token)
            localStorage.setItem('access_token', data?.access_token)
            document.cookie = `access_token=${data?.access_token}`
            document.cookie = `access_roles=${jwt?.authorities}`

            localStorage.setItem('timezone', jwt?.timezone)
            localStorage.setItem('currency', jwt?.currency)
            localStorage.setItem('language', jwt?.language)
            localStorage.setItem('user_type', jwt?.userType)
          } catch (error) {
            store.dispatch(
              'showErrorMessage',
              Vue.i18n.translate('auth.errors.retrieveToken')
            )
          }
        })
        .then(() => {
          if (
            localStorage.getItem('access_roles') &&
            localStorage.getItem('refresh_token') &&
            localStorage.getItem('access_token')
          ) {
            getUser()
          }
        })
    })
    .catch((error) => {
      store.commit('setIsLoading', false)
      store.dispatch('showErrorMessage', Vue.i18n.translate('auth.errors.login'))
    })
